module.exports = __webpack_public_path__ + "static/media/open.52d16646.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Toolbar/icons/open.svg
// module id = 912
// module chunks = 53